<script lang="ts">
import { defineComponent } from 'vue'
import { type Page, type Card, ContentPageType, ContentPageTypes } from '@/types/contentTypes'
import CardPage from '@/components/content/CardPage.vue'
import { useRoute } from 'vue-router'
import { Theme, useDisplayConfigStore } from '@/stores/displayConfig'

export default defineComponent({
  name: 'StaticContent',
  components: {
    CardPage
  },
  props: {
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      pageData: null as any | null,
      dataNotFound: null as boolean | null,
      errorCode: null as string | null,
      errorMessage: null as string | null,
      ContentPageTypes,
      ContentPageType,
      refreshKey: 0
    }
  },
  setup(props: any) {
    var name = props.name
    const route = useRoute()
    return {
      name,
      route
    }
  },
  async mounted() {
    this.refreshData()
  },
  methods: {
    async refreshData() {
      const response = await fetch(`/api/content/page?title=${this.name}`)
      if (response.ok) {
        this.pageData = await response.json()
        this.dataNotFound = false
      } else {
        this.dataNotFound = true
        this.errorCode = response.status.toString()
        this.errorMessage =
          (await response.text()) + ' Please reach out to the ITLP team for assistance.'

        // queue a retry in 5 seconds
        setTimeout(() => {
          this.refreshData()
        }, 5000)
      }

      const displayConfig = useDisplayConfigStore()
      if (this.pageData?.type === ContentPageType.CardPage) {
        displayConfig.setTheme(Theme.Dark)
      } else {
        displayConfig.setTheme(Theme.Light)
      }

      this.refreshKey++
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        if (this.$route.path === '/') {
          this.name = 'home'
        } else {
          this.name = this.$route.path.split('/').pop()
        }
        this.refreshData()
      }
    }
  }
})
</script>

<template>
  <v-container :fluid="true" style="max-width: 1500px" :key="refreshKey">
    <template v-if="dataNotFound">
      <v-card>
        <v-card-title>Error: {{ ' ' + errorCode }}</v-card-title>
        <v-card-text>{{ errorMessage }}</v-card-text>
      </v-card>
    </template>
    <template v-else-if="pageData == null">
      <v-col style="display: flex; width: 100%; justify-content: center">
        <v-progress-circular indeterminate color="primary" size="80"></v-progress-circular>
      </v-col>
    </template>
    <template v-else>
      <template v-if="pageData.type === ContentPageType.StandardPage">
        <v-card>
          <v-card-title class="pl-10 pr-10">{{ pageData.title }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text v-html="pageData.data" class="pt-5 pl-10 pr-10 pb-5"></v-card-text>
        </v-card>
      </template>
      <template v-else-if="pageData.type === ContentPageType.CardPage">
        <CardPage :pageData="pageData" />
      </template>
    </template>
  </v-container>
</template>

<style scoped lang="css">
.v-card-title {
  font-size: 28px;
  font-weight: bold;
}
</style>
